// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-loader[data-v-9032db88]{position:fixed;width:100vw;height:1000vh;background-color:rgba(var(--q4s-white-rgb),.85);display:flex;align-items:center;justify-content:center;z-index:8}.ui-loader img[data-v-9032db88]{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;
